import { Locales, withIntlProvider } from '@ratehub/base-ui';

import MESSAGES from '../definitions/FrenchMessages';


function withFrenchLocale(Component) {
    return withIntlProvider({
        Component,
        locale: Locales.FRENCH,
        messages: MESSAGES,
    });
}

export default withFrenchLocale;
